// extracted by mini-css-extract-plugin
export default {"wrapper":"Default_wrapper__xE+g2"};